import React, {Component} from 'react';
import {Switch} from "react-router";
import {Route, withRouter} from "react-router-dom";
import {withStyles} from '@material-ui/core/styles';
import {Drawer} from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import GroupIcon from '@material-ui/icons/Group';
import SettingsIcon from '@material-ui/icons/Settings';
import ListItemText from "@material-ui/core/ListItemText";
import {loadLatestInstance} from "../../../actions";
import {connect} from "react-redux";
import LoginPanel from "../LoginPanel/LoginPanel";
import Divider from '@material-ui/core/Divider';
import EntriesPage from "../EntriesPage/EntriesPage";
import {Link} from "react-router-dom";
import PlayersPage from "../PlayersPage/PlayersPage";
import actions from '../../../actions'
import ExportsPage from "../ExportsPage/ExportsPage";
import {DownloadIcon} from "../../../util/Util";

const drawerWidth = 240;

const styles = (theme) => ({
    drawer: {
        width: drawerWidth,
        flexShrink: 0
    },
    drawerPaper: {
        width: drawerWidth,
        marginTop: 64
    },
    contentDiv: {
        marginLeft: 264
    }
});

class AdminPage extends Component {

    componentDidMount() {
        if (!this.props.currentInstance) {
            this.props.loadLatestInstance();
        }
    }

    selectedMenuItem = () => {
        if (!this.props.location) {
            return '';
        }
        const path = this.props.location.pathname;
        if (path.indexOf('/admin/players') !== -1) {
            return 'Players';
        } else if (path.indexOf('/admin/export') !== -1) {
            return 'Export';
        }
        return '';
    };

    logoutHandler = () => {
        this.props.logout();
    };

    contentPanel = () => {
        const {classes} = this.props;


        return (
            <div className={classes.contentDiv}>
                <Switch>
                    <Route exact path={process.env.REACT_APP_PREFIX + "/admin"}>
                        <div>This is the content of the main settings page for the tournament</div>
                    </Route>
                    <Route path={process.env.REACT_APP_PREFIX + "/admin/entries"}>
                        <EntriesPage />
                    </Route>
                    <Route path={process.env.REACT_APP_PREFIX + "/admin/players"}>
                        <PlayersPage />
                    </Route>
                    <Route path={process.env.REACT_APP_PREFIX + "/admin/export"}>
                        <ExportsPage />
                    </Route>
                </Switch>
            </div>
        );
    };

    render() {
        const {token, classes} = this.props;

        //const menuItems = ['Settings', 'Entries', 'Players', 'Foo'];
        const menuItems = [
            {text: 'Players', linkTo: '/admin/players', icon: <GroupIcon />},
            {text: 'Settings', linkTo: '/admin', icon: <SettingsIcon />},
            {text: 'Export', linkTo: '/admin/export', icon: <DownloadIcon /> }
            // {text: 'Entries', linkTo: '/admin/entries', icon: <ListIcon />},
        ];

        let loginPanel = null;
        let logout = null;
        if (!token) {
            loginPanel = <LoginPanel />;
        } else {
            console.log("Adding logout menu for " + this.props.fullName);
            const divider = <Divider key="logout-divider" />;
            const logoutItem = (
                <ListItem button onClick={() => {this.logoutHandler()}} key={"logout-" + this.props.username}>
                    <ListItemIcon><AccountBoxIcon/></ListItemIcon>
                    <ListItemText primary="Logout" secondary={this.props.fullName} />
                </ListItem>
            );

            logout = [divider, logoutItem];

            loginPanel = this.contentPanel();
        }

        const selectedItem = this.selectedMenuItem();
        const menuItemList = menuItems.map((menuItem, index) => {
            const text = menuItem.text;
            const linkTo = process.env.REACT_APP_PREFIX + menuItem.linkTo;
            if (menuItem.linkTo) {
                return (
                    <ListItem button key={text} selected={text === selectedItem} component={Link} to={linkTo}>
                        <ListItemIcon>{menuItem.icon}</ListItemIcon>
                        <ListItemText primary={text} />
                    </ListItem>
                );
            } else {
                return (
                    <ListItem button key={text} selected={text === selectedItem} component={Link} to={menuItem.href}>
                        <ListItemIcon>{menuItem.icon}</ListItemIcon>
                        <ListItemText primary={text} />
                    </ListItem>
                );
            }
        }) ;

        return (

            <>
                <div>
                    <Drawer
                        className={classes.drawer}
                        variant="persistent"
                        anchor="left"
                        open={true}
                        classes={{
                            paper: classes.drawerPaper
                        }}
                    >
                        <List>
                            {menuItemList}
                            {logout}
                        </List>
                    </Drawer>
                </div>
                {loginPanel}
            </>
        )
    }

}

const mapStateToProps = (state) => {
    console.log("AdminPage::mapStateToProps");
    return {
        currentPage: state.root.currentAdminPage,
        token: state.root.currentToken,
        username: state.root.username,
        loginStatus: state.root.loginStatus,
        fullName: state.root.fullName,
        currentInstance: state.root.currentInstance
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadLatestInstance: () => dispatch(loadLatestInstance('Czech Open')),
        logout: () => dispatch({type: actions.LOGOUT})
    };
};

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(withRouter(AdminPage)));